import { t } from 'ttag'

import { appendSearchResults, initSearchResults } from './search'

import * as h2Api from '../h2Api'

export const MILITARY_LOADED = 'MILITARY_LOADED'
export const MILITARY_SELECT_LOADED = 'MILITARY_SELECT_LOADED'
export const MILITARY_LOADED_LOG = 'MILITARY_LOADED_LOG'
export const RATE_MOC = 'RATE_MOC'
export const MILITARY_CREATE_PLAN = 'MILITARY_CREATE_PLAN'
export const MILITARY_SEARCH = 'MILITARY_SEARCH'
export const SELECT_MOC_FOR_COMPARISON = 'SELECT_MOC_FOR_COMPARISON'
export const REMOVE_MOC_FOR_COMPARISON = 'REMOVE_MOC_FOR_COMPARISON'
export const MOC_COMPARISON = 'MOC_COMPARISON'
export const MOC_COMPARISON_SET_ERROR = 'MOC_COMPARISON_SET_ERROR'
export const CLEAR_MOC_COMPARISON = 'CLEAR_MOC_COMPARISON'
export const ADD_MILITARY_SEARCH = 'ADD_MILITARY_SEARCH'

export const loadMilitary = mocId => (dispatch, getState) => {
  return dispatch(h2Api.get(`/military/profile/${mocId}`)({ type: MILITARY_LOADED }))
}

export const selectLocalTab = () => dispatch => {
  return Promise.resolve(true)
}

export const rateMilitary = (moc, ratingType) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.put(`/user/rate/military/${moc}`, {
      rating: ratingType
    })({ type: RATE_MOC, id: moc })
  )
}

export const search = term => form => dispatch => {
  const { types, ...rest } = form
  const data = {
    term,
    types,
    filters: form
  }

  return dispatch(
    h2Api.post(`/api/v1/military/search`, data)({ type: MILITARY_SEARCH })
  ).then(v => {
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentMilitaryResults = (term, filters) => (
  startIdx,
  endIdx
) => dispatch => {
  const updatedJson = {
    filters,
    term,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/military/search`, updatedJson)({ type: ADD_MILITARY_SEARCH })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}

export const selectForComparison = id => (dispatch, getState) => {
  const comparisons = getState().jobs.comparison.selected.length

  console.log(id)

  if (comparisons == 4) {
    alert(t`You already have four items selected`)

    return false
  }

  return Promise.resolve(dispatch({ type: SELECT_MOC_FOR_COMPARISON, id }))
}

export const removeForComparison = id => dispatch => {
  return Promise.resolve(dispatch({ type: REMOVE_MOC_FOR_COMPARISON, id }))
}

export const compareMilitaryOccupation = jobs => dispatch => {
  const items = typeof jobs === 'string' ? [jobs] : jobs

  console.log(items, jobs)

  if (!items) {
    return Promise.resolve(
      dispatch({
        type: MOC_COMPARISON_SET_ERROR,
        error: t`No jobs specified for comparison`
      })
    )
  }

  dispatch({
    type: MOC_COMPARISON_SET_ERROR,
    error: null
  })

  return dispatch(
    h2Api.post('/military/compare', { moc: items })({ type: MOC_COMPARISON })
  )
}

export const clearMilitaryOccupationComparison = () => dispatch => {
  return Promise.resolve(dispatch({ type: CLEAR_MOC_COMPARISON }))
}
